import moment from 'moment-timezone'
import { DATETIME_FORMAT_12HR, DATETIME_FORMAT_SHORT, DATETIME_FORMAT } from '@/constants/datetime.constants'
import { minutesToMilliseconds } from '@/utilities/datetime.helper.js'
import Statistics from '@/resources/models/Statistics'

export default class HourlyStatistics extends Statistics {
  constructor (uuid = null, stats = [], attributes = {}, options = {}) {
    super(uuid, stats, attributes, options)
  }

  getChartLabelProperties () {
    let labelCallback = this.labelCallback ? this.labelCallback : undefined
    let labelProp = this.labelProperty ? this.labelProperty : 'hour'
    let labelVal = this.labelValue ? this.labelValue : 'count'
    return { callback: labelCallback, property: labelProp, value: labelVal }
  }
  /**
   * Method to convert server response into expected ChartJS data.
   *
   * vue-chartjs chart data expectation:
   *
   *  {
        labels: ['01:00', '02:00', '03:00', '04:00', '05:00', '06:00'],
        datasets: [
          {
            label: '2019-10-31',
            backgroundColor: '#f87979',
            data: [40, 20, 20, 10, 10, 15]
          }
        ]
      }
   *
   * API Response sample:
   *  [
        {
          "count": "211",
          "hour": 15
        },
        {
          "count": "3487",
          "hour": 16
        },
        {
          "count": "284",
          "hour": 17
        }
      ]
   */
  buildChartData (stats) {
    let chartProps = this.getChartLabelProperties()
    this.chartData.labels = _.map(stats, stat => {
      if (typeof chartProps.callback === 'function') {
        let timeFormat = chartProps.callback(this.date)
        let epochMillisec = minutesToMilliseconds(stat[chartProps.property])
        return epochMillisec
        // return moment(epochMillisec).format(timeFormat)
      } else if (chartProps.property === 'hour') {
        return moment(stat[chartProps.property], 'h').format(DATETIME_FORMAT_12HR)
      }
      return stat[chartProps.property]
    })

    this.chartData.datasets = [
      {
        date: this.date,
        label: !_.isEmpty(this.title) ? this.title : 'Count',
        tooltipLabelCallback: this.tooltipLabelCallback,
        backgroundColor: !_.isEmpty(this.backgroundColor) ? this.backgroundColor : '#fdbdca',
        borderColor: !_.isEmpty(this.borderColor) ? this.borderColor : '#ee3354',
        borderWidth: 1,
        data: _.map(stats, chartProps.value),
        stats: stats
      }
    ]
  }

  /**
   *  Method to group datasets for charts
   *
   * @param {*} otherGroupStats Secondary dataset to group bar chart with for comparison (ie connects & accepts)
   * @param {*} groupWithStats Primary dataset
   */
  groupChartData (otherGroupStats, groupWithStats = undefined, options = {}) {
    // check if want to group by new primary dataset
    if (!_.isUndefined(groupWithStats)) {
      this.buildChartData(groupWithStats)
    }

    let chartProps = this.getChartLabelProperties()
    let otherGroupLabels = _.map(otherGroupStats, stat => {
      return moment(stat[chartProps.property], 'h').format(DATETIME_FORMAT_12HR)
    })

    // concat distinct
    // this.chartData.labels = _.uniq(
    //   this.chartData.labels.concat(otherGroupLabels)
    // ).sort()

    this.chartData.datasets.push({
      label: !_.isEmpty(options) ? options.title : 'Count',
      backgroundColor: !_.isEmpty(options) ? options.backgroundColor : '#bce1ff',
      borderColor: !_.isEmpty(options) ? options.borderColor : '#179fff',
      borderWidth: 1,
      data: _.map(otherGroupStats, chartProps.value)
    })
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/HourlyStatistics.js